module.exports = __webpack_public_path__ + "img/UntermWasserfall.374240ad.svg";